import NativeMeta from '@/components/NativeMeta';

/**
 * Drops `<meta name="robots" content="noindex, follow">` into the document head.
 * Use for private / technical pages (auth, lk, payment, admin, etc.)
 * so they don't end up in Google / Яндекс search results.
 * `follow` is kept so crawlers still walk links back to public pages.
 */
export default function NoIndexMeta() {
  return <NativeMeta name="robots" content="noindex, follow" />;
}
